import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms/src/model";
import {FormBuilder} from "@angular/forms";
import {
  AutocompleteDto,
  CorrespondantDto,
  IAuditWebServiceClient,
  ICategorieFormulaireWebServiceClient,
  ITechnicWebServiceClient,
  RechercherDossierBloqueFilterDto
} from "app/common/resources/resources";
import * as lodash from "lodash";
import {Subscription} from "rxjs";
import {FiltreItem} from "@common/components/vos-filtres/filtre-item";
import {MomentService, UserStore, CorrespondantStore, NotificationService} from "@digicerba/common";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {EtatEnums} from "@common/enum/Etat.enum";
import {TagsDonneesManquantes} from "@common/constants/TagsDonneesManquantes";

@Component({
  selector: 'dossier-bloques-filtres',
  templateUrl: './dossier-bloques-filtres.component.html',
})
export class DossierBloquesFiltresComponent implements OnInit {

  filterForm: FormGroup;
  correspondantsCode: AutocompleteDto[] = [];
  subscr: Subscription;
  @Output() onFiltering = new EventEmitter<RechercherDossierBloqueFilterDto>();
  filtres = new Array<FiltreItem>();
  debounceTime: number = 900;
  showCorrespondantsFilter = false;

  constructor(private formBuilder: FormBuilder,
              private translateService: TranslateService,
              private notificationService: NotificationService,
              private momentService: MomentService,
              private categorieFormulaireWebService: ICategorieFormulaireWebServiceClient,
              private userStore: UserStore,
              private correspondantStore: CorrespondantStore,
              private auditWebServiceClient: IAuditWebServiceClient,
              private technicWebServiceClient: ITechnicWebServiceClient,
              private router: Router) {

    this._initForm();
  }

  _initForm() {
    this.filterForm = this.formBuilder.group({
      nomPrenomPatient: null,
      categories: null,
      debutDateCreation: null,
      finDateCreation: null,
      termine: null,
      aValider: null,
      enCours: null,
      numeroDossier: null,
      correspondantsSelected: null
    });

    this._controlRoute();
  }

  //L'url peut provenir du site central
  //statut en_cours pour les données manquantes
  //statut termine pour mon historique
  _controlRoute() {
    if (this.router && this.router.url) {
      let baseUrl = this.router.parseUrl(this.router.url);
      if (baseUrl && baseUrl.queryParams && baseUrl.queryParams["statut"] != null) {
        if (baseUrl.queryParams["statut"] === 'en_cours') {
          this.filterForm.controls.enCours.setValue(true, { emitEvent: false });
        } else if (baseUrl.queryParams["statut"] === 'termine') {
          this.filterForm.controls.termine.setValue(true, { emitEvent: false });
        }

        //on nettoie l'url pour un affichage propre
        this.router.navigate([],
          {
            queryParams: null
          }).then();

        lodash.debounce(() => {
          this.submit();
        }, this.debounceTime)();
      }
    }
    this.filterForm.valueChanges.debounceTime(this.debounceTime).subscribe(() => {
      this.submit();
    });
  }

  ngOnInit() {
    this._fillCorrespondantFilter();
  }

  _fillCorrespondantFilter() {
    if (this.userStore.isAdmin()) {
      this._fillAdminCorrespondantFilter();
    } else {
      this._fillSimpleCorrespondantFilter();
    }
  }

  _fillSimpleCorrespondantFilter() {
    let listCorrespondants = this.correspondantStore.getCorrespondants();
    if(listCorrespondants != null){
      listCorrespondants.forEach(correspondant => {
        if(correspondant != null){
          if(correspondant.tags != null &&
            (correspondant.tags.includes(TagsDonneesManquantes.FEL_GEST) ||
            correspondant.tags.includes(TagsDonneesManquantes.FEL_CONTRIB))){
            this._mapCorrespondantToAutocompleteDto(correspondant);
          }
        }
      });
    }

  }

  _fillAdminCorrespondantFilter() {
    this.technicWebServiceClient.getCorrespondants().subscribe((correspondants => {
      if (correspondants != null) {
        correspondants.forEach(correspondant => {
          this._mapCorrespondantToAutocompleteDto(correspondant);
        })
      }
    }));
  }

  _mapCorrespondantToAutocompleteDto(correspondant: CorrespondantDto) {
    let autocompleteDto = new AutocompleteDto();
    autocompleteDto.libelle = correspondant.code;
    this.correspondantsCode.push(autocompleteDto);

    if (this.correspondantsCode.length > 1) {
      this.showCorrespondantsFilter = true;
    }
  }

  submit() {
    this.buildFiltering();
    let rechercherDossierBloqueFilterDto = this.initRechercheDossierBloques();
    this.onFiltering.emit(rechercherDossierBloqueFilterDto);
  }

  //======= Gestion des filtres =======
  onRemove(filtre: FiltreItem) {
    switch (filtre.field) {
      case 'nomPrenomPatient': {
        this.filterForm.controls.nomPrenomPatient.setValue(null);
        break;
      }
      case 'debutDateCreation': {
        this.filterForm.controls.debutDateCreation.setValue(null);
        break;
      }
      case 'finDateCreation': {
        this.filterForm.controls.finDateCreation.setValue(null);
        break;
      }
      case 'termine': {
        this.filterForm.controls.termine.setValue(null);
        break;
      }
      case 'enCours': {
        this.filterForm.controls.enCours.setValue(null);
        break;
      }
      case 'aValider': {
        this.filterForm.controls.aValider.setValue(null);
        break;
      }
      case 'numeroDossier': {
        this.filterForm.controls.numeroDossier.setValue(null);
        break;
      }
      case 'correspondantsSelected': {
        this.filterForm.controls.correspondantsSelected.setValue(null);
        break;
      }
    }

    lodash.remove(this.filtres, (obj) => {
      return obj == filtre;
    });


    let rechercheInstanceFormulaireDto = this.initRechercheDossierBloques();
    if (rechercheInstanceFormulaireDto != null) {
      this.onFiltering.emit(rechercheInstanceFormulaireDto);
    }
  }

  private initRechercheDossierBloques(): RechercherDossierBloqueFilterDto {
    let rechercherDossierBloqueFilterDto = new RechercherDossierBloqueFilterDto();

    rechercherDossierBloqueFilterDto.etatEnums = [];

    rechercherDossierBloqueFilterDto = this._bindFiltreToDto(rechercherDossierBloqueFilterDto);

    if (rechercherDossierBloqueFilterDto.debutDateCreation != null &&
      rechercherDossierBloqueFilterDto.finDateCreation == null) {
      let dateDebut: Date = new Date(rechercherDossierBloqueFilterDto.debutDateCreation);
      dateDebut.setMonth(dateDebut.getMonth() + 6);
      if (dateDebut < new Date()) {
        this.notificationService.showErrorNotification("ERRORS.date_limite");
        return null;
      }
    } else if (rechercherDossierBloqueFilterDto.debutDateCreation != null &&
      rechercherDossierBloqueFilterDto.finDateCreation != null) {
      let dateDebut: Date = new Date(rechercherDossierBloqueFilterDto.debutDateCreation);
      let dateFin: Date = new Date(rechercherDossierBloqueFilterDto.finDateCreation);
      dateDebut.setMonth(dateDebut.getMonth() + 6);
      if (dateDebut < dateFin) {
        this.notificationService.showErrorNotification("ERRORS.date_limite");
        return null;
      }
    }

    return rechercherDossierBloqueFilterDto;
  }

  _bindFiltreToDto(rechercherDossierBloqueFilterDto: RechercherDossierBloqueFilterDto): RechercherDossierBloqueFilterDto {
    this.filtres.forEach(f => {
      switch (f.field) {
        case 'nomPrenomPatient':
          rechercherDossierBloqueFilterDto.nomPrenomPatientRefLabo = f.value;
          break;
        case 'correspondantsSelected' : {
          if (rechercherDossierBloqueFilterDto.codesCorrespondants == null) {
            rechercherDossierBloqueFilterDto.codesCorrespondants = [];
          }
          rechercherDossierBloqueFilterDto.codesCorrespondants.push(f.value.libelle);
          break;
        }
        case 'debutDateCreation':
          rechercherDossierBloqueFilterDto.debutDateCreation = this.momentService.formatToLocalDate(f.value);
          break;
        case 'finDateCreation':
          rechercherDossierBloqueFilterDto.finDateCreation = this.momentService.formatToLocalDate(f.value);
          break;
        case 'termine':
          rechercherDossierBloqueFilterDto.etatEnums.push(f.value ? EtatEnums.TERMINE.value() : null);
          break;
        case 'enCours':
          rechercherDossierBloqueFilterDto.etatEnums.push(f.value ? EtatEnums.EN_COURS.value() : null);
          break;
        case 'aValider':
          rechercherDossierBloqueFilterDto.etatEnums.push(f.value ? EtatEnums.A_VALIDER.value() : null);
          break;
        case 'numeroDossier':
          rechercherDossierBloqueFilterDto.numeroDossier = f.value;
          break;
      }
    });
    return rechercherDossierBloqueFilterDto;
  }

  buildFiltering() {
    let formValues = this.filterForm.value;

    lodash.remove(this.filtres, function (o) {
      return o.field == 'nomPrenomPatient' ||
        o.field == 'debutDateCreation' ||
        o.field == 'finDateCreation' ||
        o.field == 'termine' ||
        o.field == 'enCours' ||
        o.field == 'aValider' ||
        o.field == 'numeroDossier' ||
        o.field == 'correspondantsSelected';
    });

    if (formValues.nomPrenomPatient) {
      this.filtres.push(new FiltreItem('nomPrenomPatient', formValues.nomPrenomPatient, formValues.nomPrenomPatient));
    }

    if (formValues.correspondantsSelected) {
      if (this.filtres.find(c => c.value == formValues.correspondantsSelected.libelle) == undefined) {
        this.filtres.push(new FiltreItem('correspondantsSelected', formValues.correspondantsSelected.libelle, formValues.correspondantsSelected));
      }
    }

    if (formValues.debutDateCreation) {
      let libelleDebut = this.translateService.instant("PAGE.DOSSIERS_BLOQUES.FILTRE.debutDateCreationFiltre") + this.momentService.formatDateTime(formValues.debutDateCreation);
      this.filtres.push(new FiltreItem('debutDateCreation', libelleDebut, formValues.debutDateCreation));
    }

    if (formValues.finDateCreation) {
      let libelleFin = this.translateService.instant("PAGE.DOSSIERS_BLOQUES.FILTRE.finDateCreationFiltre") + this.momentService.formatDateTime(formValues.finDateCreation);
      this.filtres.push(new FiltreItem('finDateCreation', libelleFin, formValues.finDateCreation));
    }

    if (formValues.enCours) {
      this.filtres.push(new FiltreItem('enCours', "PAGE.DOSSIERS_BLOQUES.FILTRE.enCours", formValues.enCours));
    }

    if (formValues.aValider) {
      this.filtres.push(new FiltreItem('aValider', "PAGE.DOSSIERS_BLOQUES.FILTRE.aValider", formValues.aValider));
    }

    if (formValues.termine) {
      this.filtres.push(new FiltreItem('termine', "PAGE.DOSSIERS_BLOQUES.FILTRE.termine", formValues.termine));
    }

    if (formValues.numeroDossier) {
      this.filtres.push(new FiltreItem('numeroDossier', formValues.numeroDossier, formValues.numeroDossier));
    }

    this.logAuditFiltre();

  }

  logAuditFiltre() {
    let messageAudit = "Client " + this.userStore.getUser().login + " - Recherche modele – ";
    this.filtres.forEach((filtre, index) => {
      if (index > 0) {
        messageAudit += ", ";
      }
      messageAudit += filtre.field + "=" + filtre.value;
    });

    this.auditWebServiceClient.info({message: messageAudit}).subscribe(() => {
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/dossier-bloques/dossier-bloques-filtres/dossier-bloques-filtres.component.ts